import React from "react";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import qs from 'qs';
import ElectionResult from './result';
import StateResult from "./stateresult";

export default class ElectionLayout extends React.Component {
    constructor(props) {
        super(props);
        // console.log(props);
        this.state = {};

    }

    componentDidMount() {
        // console.log(this.props);
    }

    // componentWillReceiveProps(nextProps) {

    // }



    render() {
        let params = qs.parse(window.location.search, { ignoreQueryPrefix: true });
       
        return (
            <div>

                <link rel="stylesheet" href="/Assets/css/election.css" />
                <link rel="stylesheet" href="/Assets/css/mediasports.css" />

                <Switch>
                    <Route exact path={'/election/result'} render={(props) => <ElectionResult {...props} queryparams={params} />} />
                    <Route exact path={'/election/stateresult'} render={(props) => <StateResult {...props} queryparams={params} />} />
                </Switch>

            </div>
        )
    }
}
